import { generateInvoiceHeaders } from 'config';
import './style.scss';
import { useFetch } from 'hooks';
import { useEffect, useState } from 'react';
import Table from '../batch-upload/components/table';
import { BottomSection, ContentWrapper, DateRangePicker, NoRecord, SelectMenu, TitleSection, Button } from 'components/generic';
import { cloneDeep, sumBy } from 'lodash';
import moment from 'moment';
import { amountFormatter, getValuesById, textFormatter, arrayBufferToBlob } from 'utils';

const GenerateInvoice = () => {
	const [slabData, setSlabData] = useState();
	const [listingData, setListingData] = useState();
	const [generatePage, setGeneratePage] = useState();
	const [tableDataCount, setTableDataCount] = useState(null);
	const [invoiceData, setInvoiceData] = useState();
	const [tableWidth, setTableWidth] = useState();
	const [createObj, setCreateObj] = useState({});

	const api = useFetch();

	const listAPI = async () => {
		setTableWidth(`${sumBy(generateInvoiceHeaders, 'columnWidth')}px`);
		const { data } = await api({ url: 'client/v1/listInvoice', method: 'post' });
		const listing = data?.data?.at()?.results?.map(el => ({
			...el,
			c_invoiceAmount: amountFormatter(el?.c_invoiceAmount, el?.c_currencyCode),
			durationEnd: moment(el?.durationEnd).format('DD-MM-YYYY'),
			createdAt: moment(el?.createdAt).format('DD-MM-YYYY'),
			durationStart: moment(el?.durationStart).format('DD-MM-YYYY')
		}));
		setListingData(listing);
		setTableDataCount(listing?.length);
	};

	useEffect(() => {
		listAPI();
		clientList();
	}, []);

	const reset = () => {
		setGeneratePage(null);
		setCreateObj({});
		setInvoiceData();
	};

	const addButtonToggler = () => {
		setGeneratePage(true);
	};

	const handleDownload = async () => {
		const payload = { c_id: createObj?.c_id, from: createObj?.c_invoiceRange?.at(), to: createObj?.c_invoiceRange?.at(1) };
		const { data } = await api({ url: 'client/v1/downloadInvoice', method: 'post', data: payload });
		const buffer = data?.data?.data;
		arrayBufferToBlob(buffer, 'download', `${createObj?.c_id}_invoice.csv`, 'csv');
	}

	const setSavePopupState = e => {
		e === 'Goback' && reset();
		e === 'Download' && handleDownload()
		e === 'Generate' && generateInvoiceAPI();
	};

	const clientList = async () => {
		const { data } = await api({ url: 'client/v1/listSubscriptionDetails', method: 'get' });
		setSlabData(data?.data?.map(el => ({ key: el?.c_id, value: el?.c_name })));
		reset();
	};

	const invoicePreviewAPI = async e => {
		const payload = { c_id: e?.c_id, from: e?.c_invoiceRange[0], to: e?.c_invoiceRange[1] };
		const { data } = await api({ url: 'client/v1/generateInvoice', method: 'post', data: payload });
		setInvoiceData(data?.data?.at());
	};

	const generateInvoiceAPI = async e => {
		const data = { c_id: createObj?.c_id, from: createObj?.c_invoiceRange[0], to: createObj?.c_invoiceRange[1] };
		await api({ url: 'client/v1/mailInvoice', method: 'post', data, successToaster: true });
		clientList();
	};

	const dataHandler = (e, key) => {
		setCreateObj(prevState => {
			const state = cloneDeep(prevState);
			state[key] = e;
			if (key === 'c_id') {
				state['c_invoiceRange'] = null;
				setInvoiceData(null);
			} else if (key === 'c_invoiceRange') {
				invoicePreviewAPI(state);
			}
			return state;
		});
	};

	return (
		<>
			{!generatePage && (
				<>
					<TitleSection add handleAdd={addButtonToggler} />
					{tableDataCount && (
						<>
							<div className='transaction-table__display'>
								<Table tableHeader={generateInvoiceHeaders} tableData={listingData} tableCount={tableDataCount} tableWidth={tableWidth} />
							</div>
							<p className='transaction-table__count'>Total Records {tableDataCount}</p>
						</>
					)}

					{!tableDataCount && <NoRecord header='No transactions found!' description='Please contact your Admin' height='90%' />}
				</>
			)}
			{generatePage && (
				<>
					<ContentWrapper>
						<div className='row'>
							<div className='col-3'>
								<SelectMenu label='Select Client' placeholder='Select client' menuOptions={slabData} mandatory value={getValuesById(slabData, createObj?.c_id)} onChange={e => dataHandler(e, 'c_id')} />
							</div>
							<div className='col-3'>
								<DateRangePicker
									value={createObj?.c_invoiceRange}
									label='Invoice Period'
									onChange={e => {
										dataHandler(e, 'c_invoiceRange');
									}}
								/>
							</div>
							<div className='col-3 download'>
									<Button
										primary
										compact
										label='Download'
										disabled={!(createObj?.c_id && createObj?.c_invoiceRange)}
										handleOnSubmit={() => setSavePopupState('Download')}
									/>
							</div>
						</div>
						{invoiceData && (
							<div className='row'>
								<div className='col-6'>
									<ul className='slab-list generate-invoice__table'>
										<li className='display-flex align-center flex-start slab-list__header'>
											<div className='generate-invoice__headerItem'>Features Utilised</div>
											<div className='generate-invoice__headerItem textalign-right'>Cost per Feature</div>
											<div className='generate-invoice__headerItem textalign-right'>Utilised count</div>
											<div className='generate-invoice__headerItem textalign-right'>Total Amount</div>
										</li>
										{invoiceData?.c_subscriptionAmount?.map((el, i) => (
											<li key={i} className='display-flex align-center flex-start'>
												<div className='slab-list__title generate-invoice__bodyItem font-weight-xl'>{textFormatter(el?.type)}</div>
												<div className='slab-list__title generate-invoice__bodyItem textalign-right'>{el?.type !== 'Total' && amountFormatter(el?.amount, invoiceData?.c_currencyCode)}</div>
												<div className='slab-list__title generate-invoice__bodyItem textalign-right'>{el?.totalCount}</div>
												<div className='slab-list__title generate-invoice__bodyItem textalign-right'>{amountFormatter(el?.totalCost, invoiceData?.c_currencyCode)}</div>
											</li>
										))}
									</ul>
								</div>
							</div>
						)}
					</ContentWrapper>
					<BottomSection label1='Generate' handleButtonClick={setSavePopupState} />
				</>
			)}
		</>
	);
};

export default GenerateInvoice;
